import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeDataTableService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };

  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getEmployeeProfilesByStatuses(searchText, isProfileCompleted, from, size, roleFilter = '') {
    const url = `${this.apiUrl}Profile/GetEmployeesProfileStatus?search=${searchText}&isProfileCompleted=${isProfileCompleted}&from=${from}&size=${size}&role=${roleFilter}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getEmployeesBySkillCriteria(serviceAreaSkill: any) {
    const url = `${this.apiUrl}Competency/GetEmployeesBySkillCriteria`;
    return this.http.post<any>(url, serviceAreaSkill);
  }
  getSkillsByCompetencyAndServiceLine(competencyId: number, serviceLineId: number) {
    const url = `${this.apiUrl}Competency/GetSkillsByCompetencyAndServiceLine?competencyId=${competencyId}&serviceLineId=${serviceLineId}`;
    return this.http.get<any>(url);
  }
  getEmployeeCertificationDetails() {
    const url = `${this.apiUrl}Profile/GetEmployeesCertificationDetails`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getGSDStats(fromdate, todate) {
    const url = `${this.apiUrl}RefreshEmployeeData/GetGSDStats?fromDate=${fromdate}&toDate=${todate}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getProfileCompletedCounts() {
    const url = `${this.apiUrl}Profile/GetProfileCompletedCounts`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getAccessEmployeeDashboard(searchText,  from, size,roles) {
    const url = `${this.apiUrl}AccessEmployeeDashboard/GetAccessEmployeeDashboard?search=${searchText}&from=${from}&size=${size}&roles=${roles}`;
        
    return this.http.get<any>(url, this.httpOptions);
  }
}

 